import anime from 'animejs';

export class MenuAccessibilityController {

  constructor() {
    this.trigger = document.querySelector('#site-header-accessibility-trigger');
    this.accesibilityMenu = document.querySelector('.site-header__accessibility');
    this.accesibilityMenuInner = document.querySelector('.site-header__accessibility-inner');
    this.triggerClose = document.querySelector('.site-header__accessibility .trigger-close');
    
    if (!this.trigger || !this.accesibilityMenu || !this.accesibilityMenuInner) {
      return;
    }

    this.toggleMenu = this.toggleMenu.bind(this);
    this.trigger.addEventListener('click', this.toggleMenu );
    this.isTransitioning = false;

    if (this.triggerClose) {
      this.triggerClose.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleMenu();
      });
    }

  }

  toggleMenu() {

    if (this.isTransitioning) return;
    this.isTransitioning = true;

    const targetHeight = this.accesibilityMenuInner.getBoundingClientRect().height;
    
    if (!this.trigger.classList.contains('is-active')) {
      console.log(targetHeight);
      anime({
        targets: this.accesibilityMenu,
        opacity: [0, 1],
        height: [0, targetHeight],
        duration: 200,
        easing: 'linear',
        changeComplete: (anim) => {
          this.isTransitioning = false;
          this.accesibilityMenu.classList.remove('is-hidden');
          this.trigger.classList.add('is-active');
          this.accesibilityMenu.removeAttribute('style');
        }
      });
    } else {
      this.trigger.classList.remove('is-active');
      anime({
        targets: this.accesibilityMenu,
        opacity: [1, 0],
        height: [targetHeight, 0], 
        duration: 200,
        easing: 'linear',
        complete: (anim) => {
          this.isTransitioning = false;
        },
        changeComplete: (anim) => {
          this.accesibilityMenu.classList.add('is-hidden');
          this.accesibilityMenu.removeAttribute('style');
        }
      });
    }
    
  }

}

